import { EventBus } from '@/plugins/event-bus'
import CustomerSearchType from '@/helpers/enums/customerSearchType.js'
import Customers from 'api-client/Customers'
import { extend } from 'lodash'

const moduleState = {
  searchResults: [],
  query: '',
  showModal: false,
  showNewCompanyModal: false,
  recommendedCompany: null,
}

const getters = {
  searchResults: (state) => state.searchResults,
  searchQuery: (state) => state.query,
  showModal: (state) => state.showModal,
  showNewCompanyModal: (state) => state.showNewCompanyModal,
  recommendedCompany: (state) => state.recommendedCompany,
}

const mutations = {
  setSearchResults: (state, companies) => {
    state.searchResults = companies
    EventBus.$emit('companies/searchResults')
  },
  setCustomerDetail: (state, payload) => {
    var company = state.searchResults?.find(
      (x) => x.CustomerCompanyMagicNumber === payload.CustomerCompanyMagicNumber
    )
    if (company) {
      company = extend(company, payload)
    }
  },
  setSearchQuery: (state, query) => {
    state.query = query
  },
  showNewCompanyModal: (state, showModal) => {
    state.showNewCompanyModal = showModal
    EventBus.$emit('companies/showNewCompanyModal')
  },
  setRecommendedCompany: (state, recommendedCompany) => {
    state.recommendedCompany = recommendedCompany
    EventBus.$emit('companies/recommendedCompany')
  },
}

const actions = {
  async setSearchResults({ commit }, results) {
    commit('setSearchResults', results)
  },
  async getCompanyByMagicNumber({ commit }, magicNumber) {
    const result = await Customers.getCustomerByMagicNumber({
      magicNumber: magicNumber,
      type: CustomerSearchType.company,
    })
    commit('setCustomerDetail', result)
  },
  resetSearchResults({ commit }) {
    commit('setSearchResults', [])
  },
  setSearchQuery({ commit }, query) {
    commit('setSearchQuery', query)
  },
  showNewCompanyModal({ commit }, showModal) {
    commit('showNewCompanyModal', showModal)
  },
  async setRecommendedCompany({ commit }, result) {
    commit('setSearchResults', [result])
    commit('setRecommendedCompany', result)
  },
  resetRecommendedCompany({ commit }) {
    commit('setSearchResults', [])
    commit('setRecommendedCompany', null)
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
